module.exports = __webpack_public_path__ + "static/media/slider6img.66ff3e3e.jpg";